import type { FormaPagamento } from "../Components/Shared/Interfaces/FormaPagamento";
import { ServiceBase } from "./ServiceBase";

export class FormaPagamentoService extends ServiceBase{
  
  async getAll() {
    return this.get('/api/FormaPagamentos/Buscar');
  }

  async postItem(item: FormaPagamento) {
    return this.post('/api/FormaPagamentos/Adicionar', item);
  }

  async putItem(item: FormaPagamento) {
    return this.put('/api/FormaPagamentos/Atualizar', item);
  }

  async postDeleteItem(id: number) {
    return this.delete(`/api/FormaPagamentos/Deletar/${id}`);
  }
} 